import * as React from 'react';
import { StepIndicatorProps } from '../types';

const StepIndicator: React.FC<StepIndicatorProps> = ({ step, label, isActive, isCompleted }) => {
  return (
    <div className={`step-indicator ${isActive ? 'active' : ''}`}>
      <div className={`step-circle ${isCompleted ? 'completed' : ''}`}>
        {isCompleted ? '✓' : step}
      </div>
      <div className="step-label">{label}</div>
    </div>
  );
};

export default StepIndicator;